import { useQuery } from '@tanstack/react-query';
import { ExtraQueryParams } from 'helpers/utils/reactQuery';
import { getAssembleiasAssessorBffEndpoint } from 'library/Apis';
import { Queries } from 'library/queries';
import ApiService from './ApiService';

export type Notifications = {
  id: number;
  title: string;
};

// export type NotificationElements = {
//   totalElements: number;
//   totalPages: number;
//   elements: Notifications[];
// };

// export type NotificationElements = {
//   idEvento: number;
//   titulo: string;
// };

export const useGetNotifications = (
  extra?: ExtraQueryParams<Notifications[]>
) => {
  const url = `${getAssembleiasAssessorBffEndpoint()}duvida/nao-lido`;

  const queryFn = async () => {
    const req = await ApiService.get<Notifications[]>(url);
    return req.data;
  };

  return useQuery<Notifications[]>({
    queryKey: [Queries.GetNotifications],
    staleTime: 1000 * 60 * 10, // 10 minutos
    retry: 2,
    retryDelay: 1000 * 2, // 2 segundos
    ...(extra ?? {}),
    queryFn,
  });
};
